// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"103ff774","952":"f9d545ad"}[chunkId] + ".chunk.js";
};